import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'aw-accessibility-banner',
  imports: [CommonModule],
  templateUrl: './accessibility-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessibilityBannerComponent {
  mainColor: InputSignal<string> = input('#1e3a8a');
  textColorTop: InputSignal<string> = input('white');
  textColorBottom: InputSignal<string> = input('black');

  public showText: boolean = false;

  public toggleText(): void {
    this.showText = !this.showText;
  }
}
